module.exports = __webpack_public_path__ + "static/what-are-cryptocurrency-exchanges-c7c585027787293358dfd515aaa2a305.svg";